export default {
  SUBS: "subs",
  SUBS_PROFORMA: (code) => `subs/proforma/${code}`,
  SUBS_RECEIPT: (code) => `subs/receipt/${code}`,
  SUBS_CERTIFICATE: "subs/certificate",
};
